export const config = {
  contentful: {
    apiUrl: 'https://cdn.contentful.com/spaces/k92fldv75np5/entries',
    accessToken: 'GBmkx9S7sbqmcEQxPH9FN2qvKdUdUXIlQ5EWeTSDAa8',
  },
};
